import { render, staticRenderFns } from "./LinkTicketingAccount.vue?vue&type=template&id=657fd1cc&"
import script from "./LinkTicketingAccount.vue?vue&type=script&lang=js&"
export * from "./LinkTicketingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports